import ModalWrapper from '../../common/Modal/ModalWrapper'
import { toggleModal } from '../../../reducers/modalReducer'
import Button from '../../common/Button'

const AdminPermissionGrant = ({ handleSwtichUser, dispatch }) => {
    return (
        <>
            <ModalWrapper
                modalType={"permissionSwitchConfirmation"}
                modalCardClasses={"maw500"}
            >

                <h1 className='c15 fs2rem tac lh1 fw600 mb2rem'>
                    Confirmation
                </h1>
                <div className='c15 py1rem tac fs14px'>You are about to transfer the Admin/Owner rights of this Company or Firm to a different user. You will lose Admin/Owner rights when you click Confirm' and a dropdown or table of standard Members is shown with the option to select the new Admin/Owner.</div>
                <div className='df jcc gg1rem mt2rem'>
                    <Button
                        type={"button"}
                        onClick={() => dispatch(toggleModal({ open: '' }))}
                        text={"Cancel"}
                        btnType="default"
                        textClassName="c1"
                    />
                    <Button
                        type={"button"}
                        btnType={"warning"}
                        onClick={handleSwtichUser}
                        text={"Confirm"}
                    />
                </div>

            </ModalWrapper>
        </>
    )
}

export default AdminPermissionGrant